import React, { useState } from "react";
import { useUser } from "../Contexts/UserContext";

const Dropdown = ({ options, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, changeClient } = useUser();
  const [selectedOption, setSelectedOption] = useState({
    label: user.ClientName,
    value: user.ClientCode,
    compCode: user.CompCode,
  });

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    console.log(option);
    changeClient(option.compCode, option.value, option.label);
    console.log(user);
    setSelectedOption(option);
    setIsOpen(false);
  };

  return (
    <div className="dropdown">
      <div className="dropdown-header" onClick={toggleDropdown}>
        {selectedOption ? selectedOption.label : placeholder}
        <span className={`dropdown-icon ${isOpen ? "open" : ""}`}>▼</span>
      </div>
      {isOpen && (
        <div className="dropdown-list">
          {options.map((option) => (
            <div
              key={option.value}
              className="dropdown-list-item"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
